/* global lumesseAnalytics */

SU.injectedScripts.push(function($) {
    var dictionary  = new Map([
        ['Faculty/Directorate', 'Cyfadran/Cyfarwyddiaeth'],
        ['School', 'Ysgol'],
        ['Swansea University', 'Prifysgol Abertawe'],
        ['Job vacancy in Swansea University', 'Swydd wag ym Mhrifysgol Abertawe'],
        ['Swansea University job vacancy', 'Swydd wag ym Mhrifysgol Abertawe']
    ]);

    function i18n(text) {
        if ($().isWelshPage() && dictionary.has(text)) {
            return dictionary.get(text);
        } else {
            return text;
        }
    }

    function fixPageTitle() {
        var $h1 = $('h1.content-header-heading'),
            $jobTitle = $('#JDText-Title'),
            jobTitleText = $jobTitle.text();

        document.title = jobTitleText;
        $h1.text(jobTitleText);
        $jobTitle.remove();
    }

    function removeLanguageSwitcher() {
        var $languageSwitcher = $('.utility-links li').last();
        $languageSwitcher.hide();
    }

    function fixLabelForFacultyDirectorate() {
        var $label = $('#JDLabel-Param3');
        $label.text(i18n('Faculty/Directorate'));
    }

    function fixLabelForSchool() {
        var $label = $('#JDLabel-Param4');
        $label.text(i18n('School'));
    }

    function fixBackToListUrl() {
        $('#JD-ActBack a').each(function() {
            var $this = $(this),
                originalHref = $this.attr('href'),
                newHref = originalHref.replace(/list\.(aspx|php)/, '..');

            $this.attr('href', newHref);
        });
    }

    function removeSendJobToAFriendButton() {
        $('#JD-ActSendJob').remove();
    }

    function putButtonsInRow() {
        var $row = $('<div class="row">');
        $('#JD-Actions').addClass('container').prepend($row);
        $('#JD-ActBack, #JD-ActPrintPage, #JD-ActApply').addClass('col-md-4').appendTo($row);
    }

    function changeButtonsZindex() {
        var $buttonLink = $('.JD-BButtonFace');
        $($buttonLink).attr('tabindex', 0);
    }

    function makeShareUrl() {
        var language = $().isWelshPage() ? 'cy' : 'en',
            title = document.title,
            description = i18n('Job vacancy in Swansea University'),
            image = `${window.location.protocol}//${window.location.hostname}/_web/img/logo/social/job-vacancy-${language}.png`,
            url = window.location.toString(),
            siteName = i18n('Swansea University'),
            imageAlt = i18n('Swansea University job vacancy');

        return `${window.location.protocol}//${window.location.hostname}/_web/scripts/share.php?` + [
            `language=${language}`,
            `title=${encodeURIComponent(title)}`,
            `description=${encodeURIComponent(description)}`,
            `image=${encodeURIComponent(image)}`,
            `url=${encodeURIComponent(url)}`,
            `site_name=${encodeURIComponent(siteName)}`,
            `image_alt=${encodeURIComponent(imageAlt)}`
        ].join('&');
    }

    function fixFacebookLink() {
        var $facebookLink = $('.share-buttons-links-facebook a'),
            fixedHref = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(makeShareUrl())}`;
        $facebookLink.attr('href', fixedHref);
    }

    function fixTwitterLink() {
        var $twitterLink = $('.share-buttons-links-twitter a'),
            fixedHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(makeShareUrl())}`;
        $twitterLink.attr('href', fixedHref);
    }

    function fixLinkedInLink() {
        var $linkedInLink = $('.share-buttons-links-linkedin a'),
            fixedHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(makeShareUrl())}`;
        $linkedInLink.attr('href', fixedHref);
    }

    function fixWhatsAppLink() {
        var $whatsAppLink = $('.share-buttons-links-whatsapp a'),
            fixedHref = `whatsapp://send?text=${encodeURIComponent(makeShareUrl())}`;
        $whatsAppLink.attr('href', fixedHref);
    }

    function fixEmailLink() {
        var $emailLink = $('.share-buttons-links-email a'),
            fixedHref = `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(window.location.toString())}`;
        $emailLink.attr('href', fixedHref);
    }

    function fixCopyToClipboardLink() {
        var $copyToClipboardLink = $('.share-buttons-links-copy-to-clipboard a'),
            fixedClipboardText = window.location.toString();
        $copyToClipboardLink.attr('data-clipboard-text', fixedClipboardText);
    }

    function setUpAnalytics() {
        var params = new URLSearchParams(location.search);

        if (typeof lumesseAnalytics === 'object') {
            console.log('Emit event for AdvertViewed');
            lumesseAnalytics.init({
                trackingUrl: 'https://journey-service.tb.lumesse.com/acq',
                analyticUrl: 'https://message-broker.tb.lumesse.com/message/emea3_advert_interactions',
                technicalIdentifier: params.get('ID')
            });

            lumesseAnalytics.pushEvent('AdvertViewed', {
                sourceBoard:     'Website',
                advertTitle:     document.title,
                advertId:        `${params.get('ID')}-${params.get('nPostingID')}`,
                atsLanguageCode: params.get('lg'),
                clientId:        'MTU374'
            });
        }
    }

    fixPageTitle();
    removeLanguageSwitcher();
    fixLabelForFacultyDirectorate();
    fixLabelForSchool();
    fixBackToListUrl();
    removeSendJobToAFriendButton();
    putButtonsInRow();
    changeButtonsZindex();
    fixFacebookLink();
    fixTwitterLink();
    fixLinkedInLink();
    fixWhatsAppLink();
    fixEmailLink();
    fixCopyToClipboardLink();
    setUpAnalytics();
});
